export const ML_RESOURCES_PAGE_CONTENT = `\
# ML Resources

Here are some resources I've found on my CS / ML engineering journey that may be of value to you.
As I continue to learn and grow, I'll keep this list updated.

### Higher Education 🎓

- [Western Governor's University](https://wgu.edu): Competency-based Bachelor degrees
- [Georgia Tech (MS CS)](https://omscs.gatech.edu/specialization-machine-learning): Online Master's in CS with a focus on ML

### Continuous Learning 📚

- [Andrew Ng's DeepLearning.AI](https://deeplearning.ai): Good Intro to ML
- [arXiv](https://arxiv.org): e-Prints in CS, Math, and more
`